import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Container,
  Divider,
  List,
  ListItem,
  TextField,
  Typography,
} from "@mui/material";
import React, { ChangeEventHandler, FormEventHandler, useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Client, useCreateClientMutation, useUpdateClientMutation } from "../../apis/clients";

const ClientRegister = () => {
  const [updateClient] = useUpdateClientMutation();
  const [createClient] = useCreateClientMutation();
  const [values, setValues] = useState({ name: "", description: "", url: "http://" });
  const { name, description, url } = values;
  const navigate = useNavigate();
  const { pathname, state } = useLocation();
  const client = state as Client | undefined;

  const handleChange: ChangeEventHandler<HTMLInputElement> = (event) => {
    const { name: inputName, value } = event.target;
    setValues((prev) => ({ ...prev, [inputName]: value }));
  };

  const handleSubmit: FormEventHandler<HTMLFormElement> = async (event) => {
    event.preventDefault();
    if (client) {
      await updateClient({ id: client.id, ...values });
    } else {
      await createClient(values);
    }
    navigate("/clients");
  };

  useEffect(() => {
    if (pathname.includes("edit")) {
      if (!client) {
        navigate(-1);
        return;
      }
      setValues(client);
    }
  }, [client, pathname, navigate]);

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <Container maxWidth="md">
      <Box mb={2}>
        <Typography variant="h5">{client ? "Edit Client" : "Create New Client"}</Typography>
        {client ? null : (
          <Typography variant="body2" color="GrayText">
            you can create up to 5 clients
          </Typography>
        )}
      </Box>
      <form onSubmit={handleSubmit}>
        <Card>
          <CardContent>
            <List>
              <ListItem>
                <TextField
                  name="name"
                  value={name}
                  fullWidth
                  label="Client Name"
                  required
                  onChange={handleChange}
                />
              </ListItem>
              <ListItem>
                <TextField
                  name="description"
                  value={description}
                  fullWidth
                  label="Description"
                  multiline
                  onChange={handleChange}
                  helperText="Please be describe about how you will be using the api."
                  required
                />
              </ListItem>
              <ListItem>
                <TextField
                  fullWidth
                  label="URL"
                  name="url"
                  onChange={handleChange}
                  value={url}
                  required
                />
              </ListItem>
              {!client ? (
                <ListItem>
                  <Typography variant="body2">
                    Your Client will be reviewed within 5 business days. Any Clients that are
                    created without a sufficient description will be removed without notice.
                  </Typography>
                </ListItem>
              ) : null}
            </List>
          </CardContent>
          <Divider />
          <CardActions sx={{ justifyContent: "flex-end" }}>
            {client ? (
              <Button variant="contained" type="submit" color="secondary">
                Edit
              </Button>
            ) : (
              <Button variant="contained" type="submit">
                Submit
              </Button>
            )}

            <Button onClick={handleCancel}>Cancel</Button>
          </CardActions>
        </Card>
      </form>
    </Container>
  );
};

export default ClientRegister;
